const usTimezones = [
    "America/New_York",
    "America/Chicago",
    "America/Denver",
    "America/Phoenix",
    "America/Los_Angeles",
    "America/Anchorage",
    "America/Adak",
    "Pacific/Honolulu"
];

function isUSTimezone() {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return usTimezones.includes(userTimezone);
}
function getVariantId() {
    const xpath = "//*[@name='id']";
    const result = document.evaluate(
        xpath,
        document,
        null,
        XPathResult.FIRST_ORDERED_NODE_TYPE,
        null
    );
    const inputElement = result.singleNodeValue;
    if (inputElement) {
        const value = inputElement.value;
        if (value) {
            sendHTTPRequest(value);
        } else {
            setTimeout(() => {
                handleVariantChange();
            }, 500);
        }
    } else {
        console.log("Element not found");
        setTimeout(() => {
            handleVariantChange();
        }, 500);
    }
}

function getDiv() {
    return document.querySelector('.product__quantity');
}

// 创建库存信息元素的函数
function createInventoryElement(data) {
    const newDiv = document.createElement("div");
    newDiv.classList.add("Inventory-quantity");
    const newSpan = document.createElement("span");
    const newI = document.createElement("i");
    if (data > 10) {
        newSpan.textContent = "Available in U.S. warehouse – ready to ship FREE!";
        newI.classList.add("safe");
    } else if (data >= 1) {
        const dataSpan = document.createElement('span');
        dataSpan.textContent = data;
        dataSpan.style.color = '#F37E76';
        dataSpan.style.fontWeight = "bold";
        newSpan.appendChild(document.createTextNode('Only '));
        newSpan.appendChild(dataSpan);
        newSpan.appendChild(document.createTextNode('  left in U.S. warehouse – FREE & fast domestic shipping!'));
        newI.classList.add("danger");
    }
    newDiv.appendChild(newI);
    newDiv.appendChild(newSpan);
    return newDiv;
}

async function sendHTTPRequest(variantId) {
    try {
        const response = await fetch(`https://api.vivienhair.com?variantId=${variantId}`);
        const data = await response.json();
        const existingInventoryQuantity = document.querySelector('.Inventory-quantity');
        if (existingInventoryQuantity) {
            existingInventoryQuantity.remove();
        }

        if(data > 0){
          function insertInventoryElement(target) {
            const newDiv = createInventoryElement(data);
            target.appendChild(newDiv);
          }
        }

        let targetElements = getDiv();
        if (targetElements) {
            insertInventoryElement(targetElements);
        } else {
            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        const swatches = getDiv();
                        if (swatches) {
                            observer.disconnect();
                            insertInventoryElement(swatches);
                            break;
                        }
                    }
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    } catch (error) {
        console.error('Fetch error:', error);
    }
}

async function handleVariantChange() {
    if (!isUSTimezone()) {
        console.log('The user is not in the US and does not perform follow-up actions');
        return;
    }
    await getVariantId();
}

handleVariantChange();
// 监听元素创建并添加事件监听器
const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            const inputElement = document.querySelector("[sa-options-position='default']");
            if (inputElement) {
                observer.disconnect();
                inputElement.addEventListener("click", () => {
                    setTimeout(() => {
                        handleVariantChange();
                    }, 100);
                });
                break;
            }
        }
    }
});
observer.observe(document.body, { childList: true, subtree: true });